export const WEB_SOCKET_CHANNELS = {
  portalActivityFeed: 'portal-activity-feed',
};

export const WEB_SOCKET_CHANNEL_MESSAGES = {
  portalActivityFeed: {
    created: '.activity-created',
    updated: '.activity-updated',
    deleted: '.activity-deleted',
  },
  manageCompetitionSubmissions: {
    submitted: '.score-submission-submitted',
    deleted: '.score-submission-deleted',
  },
};

export const buildManageCompetitionSubmissionsChannel = (
  competitionId: number
): string => `manage.competition.${competitionId}.submissions`;
